import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 20 20">
      <path d="M6.5 12C9.53757 12 12 9.53757 12 6.5C12 3.46243 9.53757 1 6.5 1C3.46243 1 1 3.46243 1 6.5C1 9.53757 3.46243 12 6.5 12Z M10.5479 11L16.847 17" />
    </svg>
  )
}

export default Icon
